import React, { useState } from 'react';
import makeRequest from 'utils/makeRequest';
import EtimesTabs from 'components_etimes/common/Tabs/EtimesTabs';
import InViewObserver from 'components/InViewObserver';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import NewStoryCard from '../NewStoryCard';
import SectionHeader from '../../../components_v2/common/SectionHeader';
import LoaderSpinner from '../../../components_v2/common/LoaderSpinner/LoaderSpinner';
import s from './EtimesCoverLayout.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const renderStoryCard = (story, ga4Type, isLarge, ga4Label) => (
  <ErrorBoundary>
    <NewStoryCard
      title={story.hl}
      msid={story.id}
      syn={isLarge ? story.syn : ''}
      isBigHeading={isLarge}
      isLarge={isLarge}
      cardType="card_1"
      wu={story.wu}
      iconClass="videoIcon"
      cmstype={story.cmstype}
      gaIndex={story.gaindex}
      ga4Type={ga4Type}
      imagesize={story?.imagesize}
      // shouldNotlazyloadImage={shouldNotlazyloadImage}
      ga4Label={ga4Label}
    />
  </ErrorBoundary>
);

const EtimesCoverLayout = ({ sectionDataUrl }) => {
  const [isLoading, setIsLoading] = useState(true);
  //   setTimeout(() => {
  //     setIsLoading(false);
  //   }, 60000000);

  const [itemsLoaded, setItemsLoaded] = useState([]);
  const [activeTabPath, setActiveTabPath] = useState('');
  const [item, setItem] = useState(undefined);

  const [activeTab, setActiveTab] = useState(
    item && Array.isArray(item.sections) && item.sections.length
      ? item.sections[0].name
      : '',
  );

  const loadSectionData = (dataUrl, path) => {
    if (!dataUrl) {
      return;
    }
    setIsLoading(true);
    makeRequest
      .get(dataUrl, {}, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          Array.isArray(data.data.items) &&
          data.data.items.length > 0
        ) {
          setItemsLoaded(data.data.items);
          setIsLoading(false);
          if (path) {
            setActiveTabPath(path);
          }
        } else {
          setIsLoading(false);
          setActiveTabPath(path || item.path);
        }
      })
      .catch(() => {
        setIsLoading(false);
        setActiveTabPath(path || item.path);
      });
  };

  const onTabsChange = params => {
    if (params && params.clickedItem && params.clickedItem.dataUrl) {
      loadSectionData(params.clickedItem.dataUrl, params.clickedItem.path);
    }

    if (params.clickedItem.name) {
      setActiveTab(params.clickedItem.name);
    }
  };

  const itemstoRender =
    Array.isArray(itemsLoaded) && itemsLoaded.length > 0
      ? itemsLoaded
      : item?.news?.items;

  if (!isLoading && !(Array.isArray(itemstoRender) && itemstoRender.length)) {
    return null;
  }

  return (
    <InViewObserver
      inViewCallback={() => {
        if (!item) {
          setIsLoading(true);
          makeRequest
            .get(sectionDataUrl, {}, 'skipfeedengine')
            .then(data => {
              if (
                data &&
                data.data &&
                data.data.news &&
                Array.isArray(data.data.news.items) &&
                data.data.news.items.length > 0
              ) {
                setItem(data.data);
                setIsLoading(false);
              } else {
                setIsLoading(false);
              }
            })
            .catch(() => {
              setIsLoading(false);
            });
        }
      }}
      viewMargin="500px 0px 500px 0px"
    >
      <div className={s.secWrap}>
        {isLoading && (
          <div className={`${s.loader} ${!item ? s.loaderPlaceholder : ''}`}>
            <LoaderSpinner />
          </div>
        )}
        {item &&
          item.name && (
            <InViewObserver
              inViewCallback={() => {
                analyticsWrapper('ga4', {
                  event: 'user_shown',
                  type: item.ga4Type,
                });
              }}
            >
              <SectionHeader
                title={item.name}
                //   icon={item.icon}
                path={activeTabPath || item.path}
                ga4Type={item.ga4Type}
                //   shouldNotlazyloadIcon={item.id === 'cinema'}
                //   ish1={item.ish1}
              >
                {Array.isArray(item.sections) && (
                  <div className={s.tabContainer}>
                    <span className={s.line} />
                    <EtimesTabs
                      tabs={item.sections}
                      ga4Type={item.ga4Type}
                      onChangeCallback={onTabsChange}
                      active={activeTab}
                      numOfMenuItems={item.menuItems}
                    />
                  </div>
                )}
              </SectionHeader>
            </InViewObserver>
          )}
        <div className={s.col_4_6}>
          {itemstoRender &&
            Array.isArray(itemstoRender) &&
            itemstoRender.length && (
              <ul className={s.colLeft} key="colLeft">
                <li key={itemstoRender[0].id}>
                  {renderStoryCard(
                    itemstoRender[0],
                    item?.ga4Type,
                    true,
                    item.name,
                  )}
                </li>
              </ul>
            )}
          {itemstoRender &&
            Array.isArray(itemstoRender) &&
            itemstoRender.length > 1 && (
              <ul className={`${s.gridView} ${s.colRight}`} key="colRight">
                {itemstoRender.map((it, index) => {
                  if (index > 0 && index < 5) {
                    return (
                      <li key={it.id}>
                        {renderStoryCard(it, item?.ga4Type, false, item.name)}
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
            )}
        </div>
      </div>
    </InViewObserver>
  );
};

export default EtimesCoverLayout;
